var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-list',{attrs:{"show-tag-columns":"","show-tag-columns2":"","show-tag-filter":"","list":_vm.list,"columns":_vm.changedColumns,"export-data-options":_vm.exportDataOptions,"showSearchbox":_vm.showSearchbox,"before-show-menu":_vm.beforeShowMenu}})
}
var staticRenderFns = []

export { render, staticRenderFns }